import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import FolderIcon from '@/assets/images/svg/folder.svg?component';
import FalsePositiveIcon from '@/assets/images/svg/false-positive.svg?component';
import type { TFolder } from '@/_core/entities/report/models/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportFolderButton',
  props: {
    folder: null,
    isActive: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any) {

const props = __props as {
  folder: TFolder;
  isActive: boolean;
  disabled?: boolean;
};





const vulnCounts = computed(() => ({
  high: props.folder.statistics.find((s) => s.severity === 'high')?.count ?? 0,
  medium: props.folder.statistics.find((s) => s.severity === 'medium')?.count ?? 0,
  low: props.folder.statistics.find((s) => s.severity === 'low')?.count ?? 0,
}));

const hasAnyVulns = computed(() => props.folder.statistics.some((s) => s.count > 0));

const isFalsePositive = computed(() => props.folder.name === 'False Positives');

const icon = computed(() => (isFalsePositive.value ? FalsePositiveIcon : FolderIcon));

return { __sfc: true,props, vulnCounts, hasAnyVulns, isFalsePositive, icon }
}

})